import DialogContacts from './DialogContacts';

export default DialogContacts;
